import { Typography } from '@mui/material'
import { HelperWrapper } from '../helper-wrapper'

import { useStyles } from './styles'

interface TotalCountProps {
  count?: number
}

const TotalCount = ({ count }: TotalCountProps) => {
  const classes = useStyles()
  return (
    <Typography className={classes.totalCountText}>
      <HelperWrapper t="total-count-title" />
      {count}
    </Typography>
  )
}

export { TotalCount }
